<template>
    <li v-bind:class="{'uk-open': ukOpen}">
        <a class="uk-accordion-title" href="#">
            <span>{{ categoryName }}</span>
            <i class="fa-solid fa-chevron-down"></i>
        </a>

        <div class="uk-accordion-content">
            <ul class="sidebar__nav">
                <filter-sidebar-categories-item
                    v-for="category in categories"
                    :category="category"
                    :key="category.id"
                >
                </filter-sidebar-categories-item>
            </ul>
        </div>
    </li>
</template>

<script>
export default {
    name: "FilterSidebarCategories",
    mounted() {
        
    },
    data() {
        return {
            
        }
    },
    computed: {
        categoryName() {
            return this?.category?.name ?? this.translations.categories;
        },
    },
    methods: {
        
    },
    props: {
        category: {
            type: Object|Array,
            required: true
        },
        categories: {
            type: Object|Array,
            required: true
        },
        ukOpen: {
          type: Boolean,
          required: false,
          default: true
        },
        translations: {
            type: Object|Array,
            required: true,
        }
    }
}
</script>

<style scoped>
</style>